import { useState, useEffect } from 'react';
import { breakpointValues } from '../theme/breakpoints';

/**
 * Generic media query hook.
 * @param {string} query - CSS media query string, e.g. '(max-width: 768px)'
 * @returns {boolean}
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);

    // Modern browsers
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
    } else {
      mql.addListener(handler);
    }

    // Sync in case it changed between render and effect
    setMatches(mql.matches);

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handler);
      } else {
        mql.removeListener(handler);
      }
    };
  }, [query]);

  return matches;
};

/**
 * Convenience hooks for common breakpoints.
 */
export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${breakpointValues.md - 1}px)`);   // < 768px

   // < 1024px

        // >= 1024px

